import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";

import { LoginIndex } from "components/pages/login";
import { createBrowserClient } from "lib/apolloClient";
import { AuthProvider, CsrfLoader } from "lib/auth";
import { AssetsPreload, ErrorHandler } from "lib/errorHandler";
import ThemeProvider from "lib/themeProvider";

import App from "./components/app";
import { LogoutHandler } from "./lib/auth/components/logoutHandler";
import { PreviousLocation } from "./lib/previousLocation";

const apolloClient = createBrowserClient({});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AssetsPreload />
      <div className="App">
        <Router basename={process.env.PUBLIC_URL}>
          <ErrorHandler>
            <CsrfLoader>
              <ApolloProvider client={apolloClient}>
                <PreviousLocation>
                  <Routes>
                    <Route path="login/*" element={<LoginIndex />} />
                    <Route
                      path="/*"
                      element={
                        <AuthProvider>
                          <LogoutHandler>
                            <App />
                          </LogoutHandler>
                        </AuthProvider>
                      }
                    />
                  </Routes>
                </PreviousLocation>
              </ApolloProvider>
            </CsrfLoader>
          </ErrorHandler>
        </Router>
      </div>
    </ThemeProvider>
  </React.StrictMode>
);
